// noinspection JSFileReferences

import Map from "ol/Map.js";
import View from "ol/View.js";
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';
import {Draw, Modify, Select, Snap, DragRotateAndZoom, defaults as defaultInteractions} from 'ol/interaction.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {useGeographic, get} from 'ol/proj.js';
import {Vector} from "ol/layer";
import {Icon} from "ol/style";
import {Feature} from "ol";
import {Geometry, Point, Polygon} from "ol/geom";
import {GeoJSON} from "ol/format";
import {MapView} from "../../class/Map/MapView.es6";

document.querySelectorAll("venue-editor").forEach(element => {
	const mapContainer = element.querySelector("#location-map");
	new MapView(mapContainer);
	element.querySelectorAll("form input,select,textarea").forEach(input => {
		input.addEventListener("invalid", e => {
			let detailsContainingError = input.closest("details");
			detailsContainingError.open = true;
			setTimeout(() => {
				input.closest("label").scrollIntoView({
					behavior: "smooth",
					block: "nearest",
				});
			}, 100);
		});
	});
	return;

	useGeographic();

	setTimeout(() => {
			mapContainer.querySelector(".ol-attribution button").click();
		},
		250
	);

	let lonLat = [
		// position.coords.longitude,
		// position.coords.latitude,
		// -1.464587849202002,
		// 52.92684889892492,
	];
	let form = element.querySelector("form");
	let formLat = form["lat"].value;
	let formLon = form["lon"].value;
	if(formLat && formLon) {
		lonLat.push(parseFloat(formLon));
		lonLat.push(parseFloat(formLat));
	}

	const layerMapRaster = new TileLayer({
		source: new OSM(),
	});

	const map = new Map({
		interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
		target: mapContainer,
		layers: [layerMapRaster],
		view: new View({
			center: lonLat,
			zoom: 13,
		}),
	});

});
